import { Link, Outlet } from 'react-router-dom'
import { AUTH_PATHS, AUTH_PROFILE } from '../constants/auth'
import { useAccountLayout } from '../hooks/useAccountLayout'
import '../styles/account-page.scss'

export function AccountLayout() {
  const { isAuthenticated, loginFrom } = useAccountLayout()

  if (!isAuthenticated) {
    return (
      <div className="account-page">
        <div className="container">
          <header className="account-page__head">
            <h1>{AUTH_PROFILE.pageTitle}</h1>
          </header>
          <div className="account-page__empty">
            <p>{AUTH_PROFILE.emptyLoginTitle}</p>
            <p className="account-page__empty-hint">{AUTH_PROFILE.emptyLoginHint}</p>
            <Link
              to={AUTH_PATHS.login}
              state={{ from: loginFrom }}
              className="account-page__continue"
            >
              {AUTH_PROFILE.loginCta}
            </Link>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="account-page">
      <div className="container account-page__content">
        <Outlet />
      </div>
    </div>
  )
}
